module.exports = {
  ...require('./BaseModel'),
  name: 'ReportModel',
  fields: {
    ...require('./BaseModel').fields,
  }
}
